import React from "react";
import { Navigate } from "react-router";
import { EmteriaRoles } from "src/data/roles";
import AuthService from "src/services/authService";

const checkUserRole = (role: EmteriaRoles): boolean => {
    switch (role) {
        case EmteriaRoles.EmteriaAdminRole:
            return AuthService.isUserAdmin();
        case EmteriaRoles.EmteriaSalesRole:
            return AuthService.isUserMerchant();
        case EmteriaRoles.EmteriaDeveloperRole:
            return AuthService.isUserDeveloper();
        case EmteriaRoles.EmteriaSupportRole:
            return AuthService.isUserSupporter();
        case EmteriaRoles.EmteriaAccountantRole:
            return AuthService.isUserAccountant();
        default:
            return false;
    }
};

export const withRequiredRole = (WrappedComponent: React.ComponentType, roles: EmteriaRoles[]) => {
    const ComponentWithRoleCheck: React.FC = (props) => {
        const hasAccess = roles.some(checkUserRole);

        if (!hasAccess) {
            return <Navigate to="/forbidden" />;
        }

        return <WrappedComponent {...props} />;
    };

    return ComponentWithRoleCheck;
};
